module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agenda"
  }, [_c('page-bar'), _vm._v(" "), _c('h3', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "page-title"
  }, [_vm._v("Planejamento de aula")]), _vm._v(" "), _c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-body"
  }, [_c('planning-filter')], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.schoolClassLessonPlan.length) ? _c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-body"
  }, [_c('planning')], 1)]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fda26a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/app/lesson-planning/main.vue
// module id = 1091
// module chunks = 1